import React, { useMemo } from "react";
import '../../../style.css';

const coordKey = (r, c) => `${r}-${c}`;

export default function LeftPart({
  board,
  lines,
  placedValues,
  answerState,
  slotExpected,
  onPlace,
  state,
  selectedPoolIndex,
  onRemove
}) {
  const slotMap = useMemo(() => {
    const map = {};

    Object.keys(slotExpected).forEach((key) => {
      map[key] = {
        value: slotExpected[key],
        isSlot: true,
      };
    });

    return map;
  }, [slotExpected]);


  const handleSlotClick = (key) => {
    if (selectedPoolIndex == null) return;
  
    onPlace?.(key, selectedPoolIndex);
  };

  const bounds = useMemo(() => {
    let minR = board.length;
    let maxR = -1;
    let minC = board[0].length;
    let maxC = -1;
  
    board.forEach((row, r) => {
      row.forEach((cell, c) => {
        if (cell !== "") {
          minR = Math.min(minR, r);
          maxR = Math.max(maxR, r);
          minC = Math.min(minC, c);
          maxC = Math.max(maxC, c);
        }
      });
    });
  
    if (maxR === -1) {
      return board;
    }
  
    return board
      .slice(minR, maxR + 1)
      .map((row) => row.slice(minC, maxC + 1));
  }, [board]);

  const boardInfo = useMemo(() => {
    let minR = board.length;
    let maxR = -1;
    let minC = board[0].length;
    let maxC = -1;
  
    board.forEach((row, r) => {
      row.forEach((cell, c) => {
        if (cell !== "") {
          minR = Math.min(minR, r);
          maxR = Math.max(maxR, r);
          minC = Math.min(minC, c);
          maxC = Math.max(maxC, c);
        }
      });
    });
  
    return {
      minR,
      minC,
      board: board
        .slice(minR, maxR + 1)
        .map((row) => row.slice(minC, maxC + 1)),
    };
  }, [board]);



  return (
    <div
      className={`flex items-center justify-center ${state ? "leftpartIsStateWidth" : "leftpartIsNotStateWidth"}  h-full border-[3px] rounded-[16px] lg:rounded-[20px] border-[#7648B5] bg-[#FFF] `}
    >
      <div className="px-3 flex flex-col justify-center">
        {boardInfo.board.map((row, rIdx) => (
          <div key={rIdx} className="flex">
            {row.map((cell, cIdx) => {
              const key = coordKey(
                rIdx + boardInfo.minR,
                cIdx + boardInfo.minC
              );

              const slot = slotMap[key];
              const isSlot = !!slot;

              const placed = placedValues[key];
              const status = answerState?.[key];
              const isNumber =
                cell !== "" &&
                !["+", "-", "x", "/", "="].includes(cell);

              return (
                <div
                  key={cIdx}
                  data-slot={isSlot ? key : undefined}
                  onClick={() =>
                    isSlot && handleSlotClick(key)
                  }
                  onDoubleClick={() =>
                    isSlot && onRemove?.(key)
                  }
                  className={`
                  ${state ? "xl:text-[20px] lg:text-[18px] md:text-[14px] xl:w-[35px] xl:h-[35px] lg:w-[30px] lg:h-[30px] md:w-[25px] md:h-[25px]"
                   : "xl:text-[24px] lg:text-[20px] md:text-[16px] xl:w-[42px] xl:h-[42px] lg:w-[34px] lg:h-[34px] md:w-[28px] md:h-[28px]"} sm:text-[14px] xs:text-[12px] text-[10px] sm:w-[22px] sm:h-[22px] xs:w-[20px] xs:h-[20px] w-[17px] h-[17px]
                    flex
                    items-center
                    justify-center
                    
                    font-bold
                    select-none
                    transition-all
                    duration-200
                    rounded-[4px] lg:rounded-[8px]

                    ${isSlot
                      ? status === "correct"
                        ? "bg-[#E8FCF0] border-2 border-[#679F72] cursor-pointer"
                        : status === "wrong"
                          ? "bg-[#FFE8EA] border-2 border-[#B35A5E] cursor-pointer"
                          : "bg-[#EDF3E4] border border-[#909B84] cursor-pointer"
                      : cell
                        ? "border border-[#909B84] bg-[#D4E4C2]"
                        : "border border-transparent"
                    }

                    ${placed
                      ? "bg-[#D4E4C2]"
                      : ""
                    }
                  `}
                >
                  {/* operators */}
                  {!isSlot &&
                    cell &&
                    !isNumber && (
                      <span className="text-[#333]">
                        {cell}
                      </span>
                    )}

                  {/* visible numbers */}
                  {!isSlot &&
                    isNumber && (
                      <span className="text-[#111]">
                        {cell}
                      </span>
                    )}

                  {/* empty slot */}
                  {isSlot &&
                    !placed && (
                      <span className="text-[#999]">
                        ?
                      </span>
                    )}

                  {/* placed value */}
                  {isSlot && placed !== undefined && (
                    <span className="text-[#111]">
                      {placed}
                    </span>
                  )}
                </div>
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
}